//
import {
    LOAD_APPS,
    LOAD_APPS_STARTED,
    LOAD_APPS_GROUPS_STARTED,
    LOAD_APPS_GROUPS,
    SAVE_APPS_GROUPS,
    LOAD_APPS_LAUNCHER,
    LOAD_APPS_LAUNCHER_STARTED,
} from 'store/actions/abox/myAppsActions';
import Immutable from 'app/utils/immutable/Immutable';
import { get } from 'app/utils/lo/lo';

const initialState = {
    records: [],
    recordsLauncher: [],
    preferences: {},
    isLoading: false,
    isFavoritesLoading: false,
    isLauncherLoading: false,
};
/**
 * Reducer to handle app actions
 * @param state
 * @param action
 * @returns {*}
 */
export default (state = initialState, action) => {
    const { type, error, payload } = action;
    switch (type) {
        case LOAD_APPS_STARTED:
            return Immutable({ ...state, isLoading: true });

        case LOAD_APPS: {
            if (error) return Immutable({ ...state, isLoading: false });
            return Immutable({ ...state, isLoading: false, records: payload });
        }

        case LOAD_APPS_LAUNCHER_STARTED:
            return Immutable({ ...state, isLauncherLoading: true });

        case LOAD_APPS_LAUNCHER: {
            if (error) return Immutable({ ...state, isLauncherLoading: false });
            return Immutable({ ...state, isLauncherLoading: false, recordsLauncher: payload });
        }

        case LOAD_APPS_GROUPS_STARTED:
            return Immutable({ ...state, isFavoritesLoading: true });

        case LOAD_APPS_GROUPS: {
            if (error) return Immutable({ ...state, isFavoritesLoading: false });
            return Immutable({
                ...state,
                isFavoritesLoading: false,
                preferences: get(payload, 'myApp', {}),
            });
        }

        case SAVE_APPS_GROUPS: {
            if (error) return Immutable({ ...state });
            return Immutable({
                ...state,
                preferences: get(payload, 'myApp', {}),
            });
        }
        default:
            return state;
    }
};
